import React from 'react';
export const ProductHighlight = () => {
  return <div className="my-8 bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-208">
      {/* EVE Nutrition - Product 1 */}
      <div className="border border-green-200 bg-green-50 rounded-lg p-6 mb-8" data-id="element-209">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-210">
          1. EVE Nutrition - Nourishing Vanilla Protein
        </h3>
        <div className="flex items-center mb-4" data-id="element-211">
          <div className="flex" data-id="element-212">
            <span className="text-yellow-400 text-xl" data-id="element-213">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-214">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-215">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-216">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-217">★</span>
          </div>
          <span className="ml-2 font-medium" data-id="element-218">Rating: 5/5</span>
        </div>
        <div className="flex flex-col md:flex-row gap-6" data-id="element-219">
          <div className="md:w-1/3" data-id="element-220">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4kqJjdv2er7TdMSdL8fWVj/1b3f20a4-0f99-428d-b468-4f0a3745b643.png" alt="EVE Nutrition Nourishing Vegan Protein Vanille Verpackung" className="rounded-lg w-full h-auto" data-id="element-221" />
          </div>
          <div className="md:w-2/3" data-id="element-222">
            <div className="mb-4" data-id="element-223">
              <h4 className="font-bold mb-2" data-id="element-224">Vorteile:</h4>
              <ul className="list-none space-y-1" data-id="element-225">
                <li className="flex items-start" data-id="element-226">
                  <span className="text-green-600 font-bold mr-2" data-id="element-227">✅</span>
                  <span data-id="element-228">19g komplettes Protein aus 5 Quellen</span>
                </li>
                <li className="flex items-start" data-id="element-229">
                  <span className="text-green-600 font-bold mr-2" data-id="element-230">✅</span>
                  <span data-id="element-231">11 Vitamine + 9 Mineralien für Frauen</span>
                </li>
                <li className="flex items-start" data-id="element-232">
                  <span className="text-green-600 font-bold mr-2" data-id="element-233">✅</span>
                  <span data-id="element-234">Mit Taurin und Q10 für Zellschutz</span>
                </li>
                <li className="flex items-start" data-id="element-235">
                  <span className="text-green-600 font-bold mr-2" data-id="element-236">✅</span>
                  <span data-id="element-237">100% BIO-zertifizierte Proteinrohstoffe</span>
                </li>
                <li className="flex items-start" data-id="element-238">
                  <span className="text-green-600 font-bold mr-2" data-id="element-239">✅</span>
                  <span data-id="element-240">Perfekte Löslichkeit und Geschmack</span>
                </li>
                <li className="flex items-start" data-id="element-241">
                  <span className="text-green-600 font-bold mr-2" data-id="element-242">✅</span>
                  <span data-id="element-243">Speziell auf weiblichen Hormonhaushalt abgestimmt</span>
                </li>
              </ul>
            </div>
            <div className="mb-4" data-id="element-244">
              <h4 className="font-bold mb-2" data-id="element-245">Nachteile:</h4>
              <ul className="list-none space-y-1" data-id="element-246">
                <li className="flex items-start" data-id="element-247">
                  <span className="text-red-500 font-bold mr-2" data-id="element-248">❌</span>
                  <span data-id="element-249">Höherer Preis als Standardprodukte</span>
                </li>
                <li className="flex items-start" data-id="element-250">
                  <span className="text-red-500 font-bold mr-2" data-id="element-251">❌</span>
                  <span data-id="element-252">Bisher nur online erhältlich</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-4 text-gray-700" data-id="element-253">
          <p className="mb-4" data-id="element-254">
            <span className="font-bold" data-id="element-255">Zusammenfassung:</span> EVE Nutrition
            überzeugt durch seine wissenschaftlich fundierte, frauenspezifische
            Formel. Die Kombination aus fünf Proteinquellen liefert ein
            optimales Aminosäuren-Profil, während die zusätzlichen
            Mikronährstoffe gezielt die Bedürfnisse von Frauen in den
            Wechseljahren unterstützen. Trotz des höheren Preises bietet es das
            beste Preis-Leistungs-Verhältnis für nachhaltige Ergebnisse.
          </p>
          <p className="mb-4" data-id="element-256">
            <span className="font-bold" data-id="element-257">Erhältlich bei:</span>
            <span className="text-green-700 font-medium ml-2" data-id="element-258">
              ▶ EVE Nutrition - 45% Rabatt
            </span>{' '}
            |
            <span className="text-gray-700 ml-2" data-id="element-259">
              ▶ Amazon - Regulärer Preis
            </span>
          </p>
        </div>
        <div className="text-center mt-6" data-id="element-260">
          <a href="https://weesesumecontasy.com/click/1" className="inline-block bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-8 rounded-full text-lg shadow-md" data-id="element-261">
            Jetzt zum Testsieger-Angebot
          </a>
          <p className="text-xs text-gray-500 italic mt-2" data-id="element-262">
            *Das Testsieger Angebot gilt ab 3 Packungen mit dem Code FGWSTORE
            und solange der Vorrat reicht.
          </p>
        </div>
      </div>
      {/* Vetain Vegan Protein - Product 2 */}
      <div className="border border-gray-200 rounded-lg p-6 mb-6" data-id="element-263">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-264">
          2. Vetain Vegan Protein Vanille
        </h3>
        <div className="flex items-center mb-4" data-id="element-265">
          <div className="flex" data-id="element-266">
            <span className="text-yellow-400 text-xl" data-id="element-267">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-268">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-269">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-270">★</span>
            <span className="text-gray-300 text-xl" data-id="element-271">★</span>
          </div>
          <span className="ml-2 font-medium" data-id="element-272">Rating: 4/5</span>
        </div>
        <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-273">
          <div className="md:w-1/3" data-id="element-274">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qZf7sQLKDPPq9Qj1S8sCo4/Screenshot_2025-10-12_at_08.52.53.png" alt="Vetain Vegan Protein Vanille Verpackung" className="rounded-lg w-full h-auto" data-id="element-275" />
          </div>
          <div className="md:w-2/3" data-id="element-276">
            <div data-id="element-277">
              <h4 className="font-bold mb-2" data-id="element-278">Vorteile:</h4>
              <ul className="list-none space-y-1" data-id="element-279">
                <li className="flex items-start" data-id="element-280">
                  <span className="text-green-600 font-bold mr-2" data-id="element-281">✅</span>
                  <span data-id="element-282">100% BIO-zertifiziert und nachhaltig</span>
                </li>
                <li className="flex items-start" data-id="element-283">
                  <span className="text-green-600 font-bold mr-2" data-id="element-284">✅</span>
                  <span data-id="element-285">Keine künstlichen Süßstoffe</span>
                </li>
                <li className="flex items-start" data-id="element-286">
                  <span className="text-green-600 font-bold mr-2" data-id="element-287">✅</span>
                  <span data-id="element-288">In Deutschland produziert</span>
                </li>
                <li className="flex items-start" data-id="element-289">
                  <span className="text-green-600 font-bold mr-2" data-id="element-290">✅</span>
                  <span data-id="element-291">Gute Verträglichkeit</span>
                </li>
              </ul>
            </div>
            <div className="mt-4" data-id="element-292">
              <h4 className="font-bold mb-2" data-id="element-293">Nachteile:</h4>
              <ul className="list-none space-y-1" data-id="element-294">
                <li className="flex items-start" data-id="element-295">
                  <span className="text-red-500 font-bold mr-2" data-id="element-296">❌</span>
                  <span data-id="element-297">Sehr hoher Preis (ca. 50€/kg)</span>
                </li>
                <li className="flex items-start" data-id="element-298">
                  <span className="text-red-500 font-bold mr-2" data-id="element-299">❌</span>
                  <span data-id="element-300">Nur 16g Protein pro Portion</span>
                </li>
                <li className="flex items-start" data-id="element-301">
                  <span className="text-red-500 font-bold mr-2" data-id="element-302">❌</span>
                  <span data-id="element-303">Schwache Löslichkeit</span>
                </li>
                <li className="flex items-start" data-id="element-304">
                  <span className="text-red-500 font-bold mr-2" data-id="element-305">❌</span>
                  <span data-id="element-306">Fade bis bitterer Geschmack</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p className="text-gray-700 mb-4" data-id="element-307">
          <span className="font-bold" data-id="element-308">Zusammenfassung:</span> Vetain punktet mit
          Nachhaltigkeit und natürlichen Zutaten, enttäuscht aber beim
          Preis-Leistungs-Verhältnis. Für den hohen Preis bietet es zu wenig
          Protein und geschmacklich wenig Überzeugung.
        </p>
      </div>
      {/* Form Performance Protein - Product 3 */}
      <div className="border border-gray-200 rounded-lg p-6 mb-6" data-id="element-309">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-310">
          3. Form Performance Protein
        </h3>
        <div className="flex items-center mb-4" data-id="element-311">
          <div className="flex" data-id="element-312">
            <span className="text-yellow-400 text-xl" data-id="element-313">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-314">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-315">★</span>
            <span className="text-gray-300 text-xl" data-id="element-316">★</span>
            <span className="text-gray-300 text-xl" data-id="element-317">★</span>
          </div>
          <span className="ml-2 font-medium" data-id="element-318">Rating: 3/5</span>
        </div>
        <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-319">
          <div className="md:w-1/3" data-id="element-320">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8np6zTq1EtJYoRzdfneCQp/Screenshot_2025-10-12_at_08.53.56.png" alt="Form Performance Protein Verpackung" className="rounded-lg w-full h-auto" data-id="element-321" />
          </div>
          <div className="md:w-2/3" data-id="element-322">
            <div data-id="element-323">
              <h4 className="font-bold mb-2" data-id="element-324">Vorteile:</h4>
              <ul className="list-none space-y-1" data-id="element-325">
                <li className="flex items-start" data-id="element-326">
                  <span className="text-green-600 font-bold mr-2" data-id="element-327">✅</span>
                  <span data-id="element-328">Enthält Curcumin für Entzündungshemmung</span>
                </li>
                <li className="flex items-start" data-id="element-329">
                  <span className="text-green-600 font-bold mr-2" data-id="element-330">✅</span>
                  <span data-id="element-331">Gute Löslichkeit</span>
                </li>
                <li className="flex items-start" data-id="element-332">
                  <span className="text-green-600 font-bold mr-2" data-id="element-333">✅</span>
                  <span data-id="element-334">Mehrere Geschmacksrichtungen</span>
                </li>
              </ul>
            </div>
            <div className="mt-4" data-id="element-335">
              <h4 className="font-bold mb-2" data-id="element-336">Nachteile:</h4>
              <ul className="list-none space-y-1" data-id="element-337">
                <li className="flex items-start" data-id="element-338">
                  <span className="text-red-500 font-bold mr-2" data-id="element-339">❌</span>
                  <span data-id="element-340">Sehr hoher Preis</span>
                </li>
                <li className="flex items-start" data-id="element-341">
                  <span className="text-red-500 font-bold mr-2" data-id="element-342">❌</span>
                  <span data-id="element-343">Nicht frauenspezifisch formuliert</span>
                </li>
                <li className="flex items-start" data-id="element-344">
                  <span className="text-red-500 font-bold mr-2" data-id="element-345">❌</span>
                  <span data-id="element-346">Künstliche Süßstoffe</span>
                </li>
                <li className="flex items-start" data-id="element-347">
                  <span className="text-red-500 font-bold mr-2" data-id="element-348">❌</span>
                  <span data-id="element-349">Nur 15g Protein pro Portion</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p className="text-gray-700 mb-4" data-id="element-350">
          <span className="font-bold" data-id="element-351">Zusammenfassung:</span> Form setzt auf
          Curcumin als Zusatz, ist aber deutlich teurer und nicht speziell auf
          Frauen ausgelegt. Viele Nutzerinnen berichten von künstlichem
          Nachgeschmack.
        </p>
      </div>
      {/* Garden of Life Sport - Product 4 */}
      <div className="border border-gray-200 rounded-lg p-6 mb-6" data-id="element-352">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-353">
          4. Garden of Life Sport
        </h3>
        <div className="flex items-center mb-4" data-id="element-354">
          <div className="flex" data-id="element-355">
            <span className="text-yellow-400 text-xl" data-id="element-356">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-357">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-358">★</span>
            <span className="text-gray-300 text-xl" data-id="element-359">★</span>
            <span className="text-gray-300 text-xl" data-id="element-360">★</span>
          </div>
          <span className="ml-2 font-medium" data-id="element-361">Rating: 3/5</span>
        </div>
        <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-362">
          <div className="md:w-1/3" data-id="element-363">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/akH9wr8ZTj2NCeGP7DPbCF/Screenshot_2025-10-12_at_08.54.23.png" alt="Garden of Life Sport Protein Verpackung" className="rounded-lg w-full h-auto" data-id="element-364" />
          </div>
          <div className="md:w-2/3" data-id="element-365">
            <div data-id="element-366">
              <h4 className="font-bold mb-2" data-id="element-367">Vorteile:</h4>
              <ul className="list-none space-y-1" data-id="element-368">
                <li className="flex items-start" data-id="element-369">
                  <span className="text-green-600 font-bold mr-2" data-id="element-370">✅</span>
                  <span data-id="element-371">Bio-zertifiziert und NSF-getestet</span>
                </li>
                <li className="flex items-start" data-id="element-372">
                  <span className="text-green-600 font-bold mr-2" data-id="element-373">✅</span>
                  <span data-id="element-374">Vollständiges Aminosäuren-Profil</span>
                </li>
                <li className="flex items-start" data-id="element-375">
                  <span className="text-green-600 font-bold mr-2" data-id="element-376">✅</span>
                  <span data-id="element-377">20g Protein pro Portion</span>
                </li>
              </ul>
            </div>
            <div className="mt-4" data-id="element-378">
              <h4 className="font-bold mb-2" data-id="element-379">Nachteile:</h4>
              <ul className="list-none space-y-1" data-id="element-380">
                <li className="flex items-start" data-id="element-381">
                  <span className="text-red-500 font-bold mr-2" data-id="element-382">❌</span>
                  <span data-id="element-383">Sehr süßer Geschmack</span>
                </li>
                <li className="flex items-start" data-id="element-384">
                  <span className="text-red-500 font-bold mr-2" data-id="element-385">❌</span>
                  <span data-id="element-386">Nicht speziell für Frauen formuliert</span>
                </li>
                <li className="flex items-start" data-id="element-387">
                  <span className="text-red-500 font-bold mr-2" data-id="element-388">❌</span>
                  <span data-id="element-389">Sehr hoher Preis pro Portion</span>
                </li>
                <li className="flex items-start" data-id="element-390">
                  <span className="text-red-500 font-bold mr-2" data-id="element-391">❌</span>
                  <span data-id="element-392">Schwer erhältlich in Deutschland</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p className="text-gray-700 mb-4" data-id="element-393">
          <span className="font-bold" data-id="element-394">Zusammenfassung:</span> Garden of Life ist
          zwar bio-zertifiziert, aber sehr süß und teuer. Es bietet keine
          frauenspezifischen Nährstoffe und ist in Deutschland schwer verfügbar.
        </p>
      </div>
      {/* Pure Protein Vanilla - Product 5 */}
      <div className="border border-gray-200 rounded-lg p-6 mb-8" data-id="element-395">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-396">
          5. Pure Protein Vanilla
        </h3>
        <div className="flex items-center mb-4" data-id="element-397">
          <div className="flex" data-id="element-398">
            <span className="text-yellow-400 text-xl" data-id="element-399">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-400">★</span>
            <span className="text-gray-300 text-xl" data-id="element-401">★</span>
            <span className="text-gray-300 text-xl" data-id="element-402">★</span>
            <span className="text-gray-300 text-xl" data-id="element-403">★</span>
          </div>
          <span className="ml-2 font-medium" data-id="element-404">Rating: 2/5</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-405">
          <div data-id="element-406">
            <h4 className="font-bold mb-2" data-id="element-407">Vorteile:</h4>
            <ul className="list-none space-y-1" data-id="element-408">
              <li className="flex items-start" data-id="element-409">
                <span className="text-green-600 font-bold mr-2" data-id="element-410">✅</span>
                <span data-id="element-411">Günstiger Preis</span>
              </li>
              <li className="flex items-start" data-id="element-412">
                <span className="text-green-600 font-bold mr-2" data-id="element-413">✅</span>
                <span data-id="element-414">Weit verbreitet erhältlich</span>
              </li>
            </ul>
          </div>
          <div data-id="element-415">
            <h4 className="font-bold mb-2" data-id="element-416">Nachteile:</h4>
            <ul className="list-none space-y-1" data-id="element-417">
              <li className="flex items-start" data-id="element-418">
                <span className="text-red-500 font-bold mr-2" data-id="element-419">❌</span>
                <span data-id="element-420">Hoher Zuckergehalt (8g pro Portion)</span>
              </li>
              <li className="flex items-start" data-id="element-421">
                <span className="text-red-500 font-bold mr-2" data-id="element-422">❌</span>
                <span data-id="element-423">Künstliche Zusätze</span>
              </li>
              <li className="flex items-start" data-id="element-424">
                <span className="text-red-500 font-bold mr-2" data-id="element-425">❌</span>
                <span data-id="element-426">Minderwertige Proteinquellen</span>
              </li>
              <li className="flex items-start" data-id="element-427">
                <span className="text-red-500 font-bold mr-2" data-id="element-428">❌</span>
                <span data-id="element-429">Keine Mikronährstoffe</span>
              </li>
              <li className="flex items-start" data-id="element-430">
                <span className="text-red-500 font-bold mr-2" data-id="element-431">❌</span>
                <span data-id="element-432">Schlechte Löslichkeit</span>
              </li>
            </ul>
          </div>
        </div>
        <p className="text-gray-700 mb-4" data-id="element-433">
          <span className="font-bold" data-id="element-434">Zusammenfassung:</span> Pure Protein ist
          zwar günstig, aber die Qualität entspricht dem Preis. Hoher
          Zuckergehalt und künstliche Zusätze machen es ungeeignet für
          nachhaltigen Gewichtsverlust.
        </p>
      </div>
      {/* Winner highlight */}
      <div className="bg-green-50 p-6 rounded-lg border border-green-200 my-8" data-id="element-435">
        <h3 className="text-xl font-bold text-center mb-4" data-id="element-436">
          Hier kommt mit großem Abstand die Siegerin…
        </h3>
        <div className="flex justify-center mb-6" data-id="element-437">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1cDHGU57EG9fWsrg9EfLcb/Screenshot_2025-09-28_at_16.24.59.png" alt="Drei Packungen EVE Nutrition Nourishing Vegan Protein Vanille" className="w-full max-w-md rounded-lg" data-id="element-438" />
        </div>
        <h4 className="text-lg font-bold mb-2 text-center" data-id="element-439">
          1. EVE Nutrition - Nourishing Vanilla Protein
        </h4>
        <div className="flex justify-center mb-4" data-id="element-440">
          <div className="flex" data-id="element-441">
            <span className="text-yellow-400 text-xl" data-id="element-442">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-443">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-444">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-445">★</span>
            <span className="text-yellow-400 text-xl" data-id="element-446">★</span>
          </div>
        </div>
        <p className="mb-4 text-center font-medium" data-id="element-447">
          Die einzige Protein-Formel, die speziell für Frauen in den
          Wechseljahren entwickelt wurde:
        </p>
        <ul className="list-none space-y-2 mb-4 max-w-xl mx-auto" data-id="element-448">
          <li className="flex items-start" data-id="element-449">
            <span className="text-green-600 font-bold mr-2" data-id="element-450">✅</span>
            <span data-id="element-451">19g komplettes Protein aus 5 hochwertigen Quellen</span>
          </li>
          <li className="flex items-start" data-id="element-452">
            <span className="text-green-600 font-bold mr-2" data-id="element-453">✅</span>
            <span data-id="element-454">11 Vitamine + 9 Mineralien für den weiblichen Körper</span>
          </li>
          <li className="flex items-start" data-id="element-455">
            <span className="text-green-600 font-bold mr-2" data-id="element-456">✅</span>
            <span data-id="element-457">Mit Taurin und Q10 für Zellschutz und Anti-Aging</span>
          </li>
          <li className="flex items-start" data-id="element-458">
            <span className="text-green-600 font-bold mr-2" data-id="element-459">✅</span>
            <span data-id="element-460">
              100% BIO-zertifizierte Proteinrohstoffe ohne künstliche Zusätze
            </span>
          </li>
          <li className="flex items-start" data-id="element-461">
            <span className="text-green-600 font-bold mr-2" data-id="element-462">✅</span>
            <span data-id="element-463">Perfekte Löslichkeit ohne Klumpenbildung</span>
          </li>
          <li className="flex items-start" data-id="element-464">
            <span className="text-green-600 font-bold mr-2" data-id="element-465">✅</span>
            <span data-id="element-466">Hormonal optimiert für Frauen ab 40</span>
          </li>
        </ul>
        <p className="mb-4 text-gray-700" data-id="element-467">
          <span className="font-bold" data-id="element-468">Zusammenfassung:</span> EVE Nutrition hebt
          sich durch seine wissenschaftlich fundierte, frauenspezifische Formel
          deutlich von der Konkurrenz ab. Als einziger Shake in unserem Test
          berücksichtigt er die hormonellen Veränderungen in den Wechseljahren
          und liefert genau die Nährstoffe, die Frauen ab 40 für nachhaltigen
          Gewichtsverlust benötigen.
        </p>
        <p className="mb-6 text-gray-700" data-id="element-469">
          <span className="font-bold" data-id="element-470">Erhältlich bei:</span>
          <span className="text-green-700 font-medium ml-2" data-id="element-471">
            ▶ EVE Nutrition - 45% Testsieger-Rabatt
          </span>{' '}
          |
          <span className="text-gray-700 ml-2" data-id="element-472">
            ▶ Amazon - Regulärer Preis
          </span>
        </p>
        <div className="text-center mt-6" data-id="element-473">
          <a href="https://weesesumecontasy.com/click/1" className="inline-block bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-8 rounded-full text-lg shadow-md mb-3" data-id="element-474">
            VERFÜGBARKEIT PRÜFEN
          </a>
          <p className="text-xs text-gray-500 italic mt-2" data-id="element-475">
            *Das Testsieger Angebot gilt ab 3 Packungen mit dem Code FGWSTORE
            und solange der Vorrat reicht.
          </p>
        </div>
      </div>
    </div>;
};